var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImagesToText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#D3CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.2353C8 9.23876 8 8.24049 8.58579 7.62024C9.17157 7 10.1144 7 12 7H14C15.8856 7 16.8284 7 17.4142 7.62024C18 8.24049 18 9.23876 18 11.2353V14.7647C18 16.7612 18 17.7595 17.4142 18.3798C16.8284 19 15.8856 19 14 19H12C10.1144 19 9.17157 19 8.58579 18.3798C8 17.7595 8 16.7612 8 14.7647V11.2353Z",
    stroke: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17C6.89543 17 6 16.0519 6 14.8824V10.6471C6 7.98501 6 6.65399 6.78105 5.82699C7.5621 5 8.81918 5 11.3333 5H14C15.1046 5 16 5.9481 16 7.11765",
    stroke: "#1D1D1D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 10,
    r: 1,
    stroke: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.408L9.3297 11.7458C9.76135 11.4014 10.4119 11.4211 10.8175 11.791L12.8495 13.6442C13.175 13.9411 13.6874 13.9816 14.0641 13.7402L14.2053 13.6496C14.7473 13.3022 15.4807 13.3425 15.9731 13.7467L17.5 15",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImagesToText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/images-to-text.abef1d880e47be6a49b313771c31aa41.svg";